import { createContext } from 'react';

export interface ColorModeCtx {
  mode: 'light' | 'dark';
  toggleColorMode: () => void;
}

export const ColorModeContext = createContext<ColorModeCtx>({
  mode: 'light',
  toggleColorMode: () => {},
});
